






import { defineComponent, onMounted } from '@vue/composition-api';
import { getUserManager } from '../../oidc';

export default defineComponent({
    setup() {
        onMounted(() => {
            const isSilent = window.location.pathname.endsWith('silent');
            const userManager = getUserManager();

            const result = isSilent ? userManager.signinSilentCallback() : userManager.signinPopupCallback();

            result
                .then((user) => {
                    if (user && !isSilent) {
                        window.location.href = '/babel/apps';
                    } else {
                        userManager
                            .signinPopupCallback()
                            .then((user) => {
                                window.location.href = '/babel/apps';
                            })
                            .catch((e) => {
                                console.error(e);
                            });
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        });
    },
});
